/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EntityRef } from './entityRef';

export interface VerifiedDomainOut {
  id: string;
  domain: string;
  added_by: EntityRef | null;
  added_at: string;
}
